import { Footer } from '../components/Footer';
import { FOUNDING_OFFER_ID, FoundingOffer } from '../components/FoundingOffer';
import { HERO_ID, HeroSection } from '../components/HeroSection';
import { Navigation } from '../components/Navigation';
import { SectionContent } from '../components/SectionContent';
import { SectionTicker } from '../components/SectionTicker';
import { VideoBackground } from '../components/VideoBackground';
import { useSectionNavigation } from '../hooks/useSectionNavigation';
import { sections } from '../sections/sections';

/**
 * Place your machine video at: public/Machine.mp4
 * Poster frames (regenerate from MP4): public/machine-poster.jpg, public/machine-poster.webp
 */
const VIDEO_SRC = '/Machine.mp4';
const WEBM_SRC = '/machine.webm';
const POSTER_SRC = '/machine-poster.jpg';
const POSTER_WEBP_SRC = '/machine-poster.webp';

export function MarketingHome() {
  const { activeIndex, goToSection } = useSectionNavigation();

  return (
    <>
      <VideoBackground
        videoSrc={VIDEO_SRC}
        webmSrc={WEBM_SRC}
        posterSrc={POSTER_SRC}
        posterWebpSrc={POSTER_WEBP_SRC}
      />

      <Navigation />

      <main className="sections-container">
        <h1 className="sr-only">AI-Powered Subscription Revenue Management</h1>
        {sections.map((section, index) => {
          if (section.id === HERO_ID) {
            return <HeroSection key={section.id} isActive={activeIndex === index} />;
          }
          if (section.id === FOUNDING_OFFER_ID) {
            return <FoundingOffer key={section.id} isActive={activeIndex === index} />;
          }
          return (
            <SectionContent key={section.id} section={section} isActive={activeIndex === index} />
          );
        })}
      </main>

      <Footer className="site-footer--home" />

      <SectionTicker activeIndex={activeIndex} onNavigate={goToSection} />
    </>
  );
}
